import ClarityTracking from 'chimera/all/plugins/tracking/clarity'
import Vue from 'vue'

export default ({ env, store }) => {
  const options = {
    projectId: env.clarityProjectId,
    sessionId: store.getters['context/get']('sessionId'),
    visitorId: store.getters['context/get']('visitorId'),
    store,
  }

  Vue.use(ClarityTracking, options)
}
